import { AltMatSortField } from "@saleor/alternatedMaterial/urls";
import { AlternatedMaterialOsSortField } from "@saleor/graphql";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryAlternatedMaterialView(
  sort: AltMatSortField
): AlternatedMaterialOsSortField {
  switch (sort) {
    case AltMatSortField.SALE_ORG:
      return AlternatedMaterialOsSortField.SALE_ORG;
    case AltMatSortField.SOLD_TO:
      return AlternatedMaterialOsSortField.SOLD_TO;
    case AltMatSortField.MATERIAL_INPUT:
      return AlternatedMaterialOsSortField.MATERIAL_INPUT;
    case AltMatSortField.ALTERNATED_MATERIAL:
      return AlternatedMaterialOsSortField.ALTERNATED_MATERIAL;
    case AltMatSortField.DIA:
      return AlternatedMaterialOsSortField.DIA;
    case AltMatSortField.TYPE:
      return AlternatedMaterialOsSortField.TYPE;
    case AltMatSortField.PRIORITY:
      return AlternatedMaterialOsSortField.PRIORITY;
    case AltMatSortField.LAST_UPDATED_DATE:
      return AlternatedMaterialOsSortField.LAST_UPDATED_DATE;
    case AltMatSortField.LAST_UPDATED_BY:
      return AlternatedMaterialOsSortField.LAST_UPDATED_BY;
    default:
      return undefined;
  }
}

export const getSortQueryAlternateMaterialVariables = createGetSortQueryVariables(
  getSortQueryAlternatedMaterialView
);
